export const buildAddressInfo = ({ address, number, neighborhood, complement }) => {
  const basicAddressInfo = `${address}, ${number}`;
  const neighborhoodInfo = neighborhood ? `, ${neighborhood}` : '';
  const complementInfo = complement ? ` • ${complement}` : '';

  return basicAddressInfo + neighborhoodInfo + complementInfo;
};
